import * as yup from "yup";
import { licenseCheck, phoneCheck } from "../../common/regex";

export const validationSchema = yup.object().shape({
  driverDetails: yup.object().shape({
    firstName: yup.string().required("First Name is required"),
    lastName: yup.string().required("Last Name is required"),
    emailId: yup.string().email("Invalid email format").required("Email is required"),
    mobileNumber: yup
      .string()
      .matches(phoneCheck, "Invalid phone number")
      .required("Mobile number is required"),
    licenseNumber: yup
      .string()
      .matches(licenseCheck, "Invalid License Number")
      .required("License Number is required"),
    licenseType: yup.string().required("License Type is required"),
    licenseExpiry: yup.date().typeError("License Expiry is required").required("License Expiry is required"),
    panNumber: yup.string().optional(), // Changed from nullable() to optional()
    aadhaarNumber: yup.string().optional(), // Changed from nullable() to optional()
    alternativePhoneNumber: yup.string().optional(), // Changed from nullable() to optional()
    alternativeEmailId: yup.string().optional(), // Changed from nullable() to optional()
    relationWithDriver: yup.string().required("Relation is required"),
    inhouseDriver: yup.boolean().required("Inhouse Driver is required"),
  }),

  personalDetails: yup.object().shape({
    dob: yup.date().typeError("Date of Birth is required").required("Date of Birth is required"),
    bloodGroup: yup.string().required("Blood Group is required"),
    gender: yup.string()
      .oneOf(["Male", "Female", "Other"], "Select a valid gender")
      .required("Gender is required"),
    maritalStatus: yup.string().required("Marital Status is required"),
  }),

  addressDetails: yup.object().shape({
    addressLine1: yup.string().required("Address Line 1 is required"),
    addressLine2: yup.string().optional(), // Changed from nullable() to optional()
    city: yup.string().required("City is required"),
    state: yup.string().required("State is required"),
    country: yup.string().required("Country is required"),
    pincode: yup
      .string()
      .required("Pincode is required")
      .matches(/^[0-9]{6}$/, "Please enter a valid 6-digit pincode"),
  }),

  bankDetails: yup.object().shape({
    accountHolderName: yup.string().required("Account Holder Name is required"),
    accountNumber: yup.string().required("Account Number is required"),
    ifscCode: yup.string().required("IFSC Code is required"),
    bankName: yup.string().optional(), // Changed from nullable() to optional()
    branchName: yup.string().optional(), // Added for consistency with interface
    accountType: yup.string().optional(), // Changed from nullable() to optional()
    upiNumber: yup.string().optional(), // Changed from nullable() to optional()
    upiId: yup.string().optional(), // Changed from nullable() to optional()
    bankBranch: yup.string().optional(), // Changed from nullable() to optional()
  }),
});